<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'leilao',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
//      console.log('destruido')
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      }
    }
  }
</script>

<template>
    <div>
        <div class="app-content-body">
            <div class="wrapper-md" ng-controller="JVectorMapDemoCtrl">
                <div class="panel b-a">
                    <div class="panel-heading b-b b-light">Excluir Item</div>
                        <div class="panel-body">
                        Lorem Isum
                        </div>
                        <div class="wrapper-md">
                            <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            <button class="btn m-b-xs w-xs btn-danger">Excluir</button>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Excluir.vue?88d8a348